import {action} from "mobx";
import statisticService from "../services/statisticService";
import appStore from "./appStore";

class statisticStore {
    @action getCurrentStatistics = async params => {
        const resultOfRequest = await statisticService.getCurrentStatistics(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }

        return resultOfRequest.data;
    };

    @action getHistoricStatistics = async params => {
        const resultOfRequest = await statisticService.getHistoricStatistics(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action getQueueStatistics = async params => {
        const resultOfRequest = await statisticService.getQueueStatistics(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action getMergedOrderStatistics = async params => {
        const resultOfRequest = await statisticService.getMergedOrderStatistics(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action getDurationStatistics = async params => {
        const resultOfRequest = await statisticService.getDurationStatistics(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action getCourierDeliveryStatistics = async params => {
        const resultOfRequest = await statisticService.getCourierDeliveryStatistics(params);
         if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    }

    @action getCompanyOrderStatistics = async params => {
        const resultOfRequest = await statisticService.getCompanyOrderStatistics(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action getCompanyOrderHourlyStatistics = async params => {
        const resultOfRequest = await statisticService.getCompanyOrderHourlyStatistics(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action getCompanyOrderDurationStatistics = async params => {
        const resultOfRequest = await statisticService.getCompanyOrderDurationStatistics(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };
}

export default new statisticStore();
